import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './index.css';
import * as actions from 'actions';
import AccountLinkItem from './AccountLinkItem';

import { document, question } from 'common/svg/icons';

const AccountLinks = ({ onLogout }) => (
  <nav
    className="account-links is-flex"
    role="navigation"
    aria-label="account settings"
  >
    <ul className="account-links__list is-flex">
      <AccountLinkItem text="Web Support" SvgIcon={question} />
      <AccountLinkItem text="Terms & Conditions" SvgIcon={document} />
      <li
        className="account-links__logout margin--top-auto text--fade"
        onClick={onLogout}
      >
        Logout
      </li>
    </ul>
  </nav>
);

AccountLinks.propTypes = {
  onLogout: PropTypes.func.isRequired,
};

const mapDispatch = {
  onLogout: actions.onLogout,
};

export default connect(
  null,
  mapDispatch
)(AccountLinks);



// WEBPACK FOOTER //
// ./src/common/components/AccountLinks/index.js